/**
 *
 * @module mediaPlayhead
 *
 */

/**
 *
 * @class MediaPlayhead
 * @desc Represents the position of the associated media when it was last viewed by the current user.
 *
 */
export default class MediaPlayhead {

    /**
     *
     * @param {Number} position
     * @param {String} lastUpdated
     * @param {MediaPlayheadStatus} status
     *
     */
    constructor(position, lastUpdated, status) {

        /**
         *
         * @access public
         * @type {Number}
         * @desc Gets the position of the playhead in the last session for the associated media.
         *
         */
        this.position = position;

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets the timestamp when the playhead was last recorded.
         *
         */
        this.lastUpdated = lastUpdated;

        /**
         *
         * @access public
         * @type {MediaPlayheadStatus}
         * @desc Gets or sets the status of retrieving the last playhead.
         *
         */
        this.status = status;

    }

}



// WEBPACK FOOTER //
// ./src/services/media/mediaPlayhead.js